var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "answer-box" }, [
    _c("header", { staticClass: "header-box" }, [
      _c(
        "div",
        {
          staticClass: "back",
          on: {
            click: function ($event) {
              return _vm.$router.back()
            },
          },
        },
        [
          _c("img", {
            attrs: { src: require("images/back.png"), width: "10" },
          }),
          _c("span", [_vm._v("返回")]),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "answer-content" },
      [
        _c("div", { staticClass: "answer-right" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "allScore" },
            [
              _c("label", [_vm._v("从")]),
              _c("el-input", {
                staticClass: "numFrom",
                attrs: { placeholder: "" },
                model: {
                  value: _vm.setFrom,
                  callback: function ($$v) {
                    _vm.setFrom = $$v
                  },
                  expression: "setFrom",
                },
              }),
              _c("label", [_vm._v("到")]),
              _c("el-input", {
                staticClass: "numTo",
                attrs: { placeholder: "" },
                model: {
                  value: _vm.setTo,
                  callback: function ($$v) {
                    _vm.setTo = $$v
                  },
                  expression: "setTo",
                },
              }),
              _c("label", [_vm._v("题")]),
              _c("el-input", {
                staticClass: "numFrom",
                attrs: { placeholder: "" },
                model: {
                  value: _vm.setScore,
                  callback: function ($$v) {
                    _vm.setScore = $$v
                  },
                  expression: "setScore",
                },
              }),
              _c("label", { staticStyle: { margin: "0 10px 0 5px" } }, [
                _vm._v("分/题"),
              ]),
              _c(
                "div",
                { staticClass: "type-select" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "--", size: "mini" },
                      model: {
                        value: _vm.isMul,
                        callback: function ($$v) {
                          _vm.isMul = $$v
                        },
                        expression: "isMul",
                      },
                    },
                    _vm._l(_vm.choiceTypeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMul == 0,
                      expression: "isMul == 0",
                    },
                  ],
                },
                [_vm._v("请填写选不全答案的得分/题")]
              ),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMul == 0,
                    expression: "isMul == 0",
                  },
                ],
                staticClass: "numTo",
                attrs: { placeholder: "" },
                model: {
                  value: _vm.halfPoint,
                  callback: function ($$v) {
                    _vm.halfPoint = $$v
                  },
                  expression: "halfPoint",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "numOk",
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.totalOn },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "content-area",
              staticStyle: { "margin-top": "0px" },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.answerList,
                    border: "",
                    size: "mini",
                    height: "440",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "num", align: "center", label: "序号" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "大题号", prop: "bigNum", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "小题号",
                      prop: "smallNum",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "答案" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isRegion
                              ? _c("div", { staticClass: "input-font" }, [
                                  _vm._v(" " + _vm._s(scope.row.answer) + " "),
                                ])
                              : _c("div", [
                                  scope.row.choiceTypeCode == 1 ||
                                  scope.row.choiceTypeCode == 0
                                    ? _c(
                                        "div",
                                        { staticClass: "answer answer-font" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: scope.row.answer,
                                                expression: "scope.row.answer",
                                              },
                                            ],
                                            class:
                                              scope.row.answer == "" &&
                                              _vm.answerSubmitCount > 0
                                                ? "inputWraning"
                                                : "",
                                            style:
                                              scope.row.answer == ""
                                                ? "border: 1px solid #f88e05"
                                                : "",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: scope.row.answer,
                                            },
                                            on: {
                                              keydown: _vm.wantEdit,
                                              keyup: function ($event) {
                                                return _vm.editAnswer(scope.row)
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  scope.row,
                                                  "answer",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _c("span", [_vm._v("--")]),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "满分" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isRegion
                              ? _c("div", { staticClass: "input-font" }, [
                                  _vm._v(" " + _vm._s(scope.row.point) + " "),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "answer answer-font" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: scope.row.point,
                                          expression: "scope.row.point",
                                        },
                                      ],
                                      style: !scope.row.point
                                        ? "color: red"
                                        : "",
                                      attrs: { type: "text" },
                                      domProps: { value: scope.row.point },
                                      on: {
                                        keydown: _vm.wantEdit,
                                        keyup: function ($event) {
                                          return _vm.editAnswer(scope.row)
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            scope.row,
                                            "point",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "题类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isRegion
                              ? _c("div", [
                                  scope.row.choiceTypeCode == 0
                                    ? _c("span", [_vm._v("多选题")])
                                    : _vm._e(),
                                  scope.row.choiceTypeCode == 1
                                    ? _c("span", [_vm._v("单选题")])
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  scope.row.choiceTypeCode == 0 ||
                                  scope.row.choiceTypeCode == 1
                                    ? _c(
                                        "div",
                                        { staticClass: "answer" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "请选择",
                                                size: "mini",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.handleChoiceTypeChange(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.choiceTypeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "choiceTypeCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.choiceTypeCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.choiceTypeList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                            scope.row.choiceTypeCode == 2
                              ? _c("div", [_vm._v("主观题")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "题型设置", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.choiceTypeCode == 0
                              ? [
                                  scope.row.multiChooseScoringPolicy
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            color: "#2877FF",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSetCombination(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 已设置 ")]
                                      )
                                    : _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.answer !== "" &&
                                              scope.row.point !== "",
                                            "popper-class": "objective-popper",
                                            content: "请先设置答案与满分",
                                            placement: "top",
                                            effect: "light",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                width: "20%",
                                                cursor: "pointer",
                                                color: "#FF5356",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleSetCombination(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 未设置 ")]
                                          ),
                                        ]
                                      ),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "answer-count" }, [
            _c("span", [_vm._v("总计：")]),
            _c("span", [_vm._v(_vm._s(_vm.answerList.length) + " 题")]),
            _c("span", { staticStyle: { "margin-left": "10px" } }, [
              _vm._v("总分："),
            ]),
            _c("label", [_vm._v(_vm._s(_vm.scoreCount) + "分")]),
          ]),
          !_vm.isRegion && !_vm.ifHistoryData
            ? _c(
                "div",
                { staticClass: "set-button" },
                [
                  _vm.answerSubmitCount == 0
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            round: "",
                            loading: _vm.submitAnswerLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm._submitAnswer()
                            },
                          },
                        },
                        [_vm._v("确认标准答案")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: {
                            type: "warning",
                            round: "",
                            loading: _vm.submitAnswerLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm._submitAnswer()
                            },
                          },
                        },
                        [_vm._v("有题目满分为0，是否确认提交？")]
                      ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "yue-dialog",
          {
            attrs: {
              visible: _vm.combinationVisible,
              "custom-class": "combination-dialog",
              width: "500px",
              "close-on-click-modal": false,
              "close-on-press-escape": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.combinationVisible = $event
              },
            },
          },
          [
            _c("multiple-score-title", {
              attrs: { slot: "title" },
              slot: "title",
            }),
            _vm.combinationVisible
              ? _c("multiple-score-setting", {
                  attrs: { combine: _vm.editQuestion },
                  on: { close: _vm.handleCloseCombination },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-header" }, [
      _c("img", {
        attrs: { src: require("images/exam/line.png"), width: "5" },
      }),
      _c("span", { staticClass: "text" }, [_vm._v("请设置试卷答案")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }